import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../auth-service';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { CurrentUserService } from '../current-user.service';
import { ErrorVTO } from '../auth-service.model';
import { OfferFiltersApi, OfferResultSet } from '../../pages/admin-dashboard/promotions/offers-management/offers.model';
import {
  PublicOffersParams,
  PublicOffersResponse,
} from '../../components/user-dashboard-component/home-page/offers/offers.model';

@Injectable({
  providedIn: 'root',
})
export class OffersService {
  private http = inject(HttpClient);
  private API = environment.productsApiUrl;
  private authService = inject(AuthService);

  private getHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }

  autoCompleteOffers(searchTerm: string) {
    return this.http.get<{
      total: number;
      list: {
        id: number;
        titleEn: string;
        titleAr: string;
      }[];
    }>(`${this.API}/offers/auto/complete`, {
      headers: this.getHeaders(),

      params: {
        quickSearch: searchTerm,
      },
    });
  }

  private buildFilters(filters?: OfferFiltersApi): HttpParams {
    let params = new HttpParams();
    if (filters) {
      if (filters.title !== undefined) params = params.set('title', filters.title.toString());
      if (filters.pageNum !== undefined) params = params.set('pageNum', filters.pageNum.toString());
      if (filters.pageSize !== undefined) params = params.set('pageSize', filters.pageSize.toString());
      if (filters.orderBy) params = params.set('orderBy', filters.orderBy);
      if (filters.orderDir) params = params.set('orderDir', filters.orderDir);

      if (filters.startDateFrom) params = params.set('startDateFrom', filters.startDateFrom);
      if (filters.startDateTo) params = params.set('startDateTo', filters.startDateTo);
      if (filters.endDateFrom) params = params.set('endDateFrom', filters.endDateFrom);
      if (filters.endDateTo) params = params.set('endDateTo', filters.endDateTo);
      if (filters.offerTypeIds) params = params.set('offerTypeIds', filters.offerTypeIds.join(','));
      if (filters.status) params = params.set('status', filters.status.join(','));
    }
    return params;
  }

  getAllOffersByFilter(filters?: OfferFiltersApi): Observable<OfferResultSet> {
    const params = this.buildFilters(filters);
    return this.http.get<OfferResultSet>(`${this.API}/offers`, { params, headers: this.getHeaders() });
  }

  getOneOffer(offerId: string): Observable<any> {
    return this.http.get(`${this.API}/offers/${offerId}`, { headers: this.getHeaders() });
  }

  getOneCustomerOffer(offerId: string): Observable<any> {
    return this.http.get(`${this.API}/offers/public/${offerId}`, { headers: this.getHeaders() });
  }

  getPublicOffers(params: PublicOffersParams = {}): Observable<PublicOffersResponse> {
    let httpParams = new HttpParams();

    if (params.pageNum !== undefined) httpParams = httpParams.set('pageNum', params.pageNum.toString());
    if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString());
    if (params.noPagination !== undefined) httpParams = httpParams.set('noPagination', params.noPagination.toString());
    if (params.type !== undefined) httpParams = httpParams.set('type', params.type);
    return this.http.get<PublicOffersResponse>(`${this.API}/offers/public`, {
      headers: this.getHeaders(),
      params: httpParams,
    });
  }

  autoCompleteOfferProduct(offerId: string, offerTypeId: string, searchTerm: string) {
    return this.http.get<{
      total: number;
      list: {
        id: number;
        titleEn: string;
        titleAr: string;
      }[];
    }>(`${this.API}/customer/products/offers/${offerId}/offerTypes/${offerTypeId}`, {
      headers: this.getHeaders(),

      params: {
        quickSearch: searchTerm,
      },
    });
  }

  // private handleError = (error: HttpErrorResponse) => {
  //   // if (error.status === 403) {
  //   //   this.router.navigate(['/login']);
  //   //   this.currentUserService.logout();
  //   // }
  //   const apiError: ErrorVTO = error.error;
  //   return throwError(() => apiError);
  // };
}
